import VideoPlayer from '../../../../../UI/VideoPlayer/VideoPlayer';
import React, { useEffect } from 'react';

function ProductMainVideo({ poster, src, onShow }) {
  const videoJsOptions = {
    preload: true,
    autoplay: true,
    controls: false,
    loop: true,
    muted: true,
    poster: poster,
    posterImage: false,
    fluid: true,
    playsinline: true,
    responsive: true,
    controlBar: false,
    loadingSpinner: false,
    sources: [
      {
        src: src,
        type: 'video/mp4',
      },
    ],
  };

  useEffect(() => {
    onShow && onShow();
  }, []);

  return (
    <figure className='main-img-wrapper' id='main-img-wrapper'>
      <VideoPlayer options={videoJsOptions} />
    </figure>
  );
}

export default React.memo(ProductMainVideo);
